// Teaavi Coffee — content data

export const VERIFIED = {
  hero: "https://images.unsplash.com/photo-1751956066306-c5684cbcf385?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  latteTop: "https://images.unsplash.com/photo-1630748662359-40a2105640c7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  cappuccino: "https://images.unsplash.com/photo-1751956066306-c5684cbcf385?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  bakery: "https://images.unsplash.com/photo-1555507036-ab1f4038808a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  interior1: "https://images.unsplash.com/photo-1751956066306-c5684cbcf385?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  interior2: "https://images.unsplash.com/photo-1676188043163-9f16eac1f2ac?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const FALLBACK_IMG = VERIFIED.cappuccino;

export const AVG_COST = "₹200 for one order (approx.) · Exclusive of applicable taxes and charges";
export const FSSAI = "10825005001407";

const u = (id, w = 1000) =>
  `https://images.unsplash.com/photo-${id}?crop=entropy&cs=srgb&fm=jpg&q=85&w=${w}`;

export const MENU = [
  {
    key: "combos", label: "Combos", image: VERIFIED.bakery,
    subcategories: [
      { label: "Popular Combos", items: [
        { name: "Cafe Frappe With Chicken Tikka Sandwich", desc: "Blended cafe frappe paired with a tikka-marinated chicken sandwich.", price: 279 },
        { name: "Cafe Frappe With Peri Peri Fries", desc: "Creamy cafe frappe with a side of zesty peri peri fries.", price: 249 },
        { name: "Classic Cold Coffee With Bombay Grill Sandwich", desc: "Chilled cold coffee with a grilled Bombay veg sandwich.", price: 239 },
        { name: "Classic Cold Coffee With Egg & Cheese Burger", desc: "Cold coffee with a fluffy egg & cheese burger.", price: 259 },
        { name: "Classic Cold Coffee With Spicy Chicken Burger", desc: "Cold coffee with a crispy spicy chicken burger.", price: 269 },
        { name: "Classic Cold Coffee With Veg Cheese Burger", desc: "Cold coffee with a hearty veg cheese burger.", price: 239 },
        { name: "Gur Wali Chai With Bun Maska", desc: "Jaggery chai served with soft buttered bun maska.", price: 129 },
        { name: "Gur Wali Chai With Paneer Puff", desc: "Jaggery chai with a flaky spiced paneer puff.", price: 149 },
        { name: "Honey Caramel Matcha With Veg Cheese Burger", desc: "Honey caramel matcha with a veg cheese burger.", price: 279 },
        { name: "Kadak Chai With Bun Samosa", desc: "Homestyle masala chai with a toasted bun samosa.", price: 119 },
        { name: "Kadak Chai With Poha", desc: "Masala chai with a plate of light Indori poha.", price: 129 },
        { name: "Kadak Chai With Vada Pav", desc: "Masala chai with a classic spicy vada pav.", price: 119 },
        { name: "Kadak Chai With Veg Maggi", desc: "Masala chai with veggie-loaded Maggi.", price: 129 },
        { name: "Kulhad Chai With Bun Maska", desc: "Earthen-kulhad chai with soft bun maska.", price: 119 },
        { name: "Lemon Iced Tea With Chicken Cheese Burger", desc: "Refreshing lemon iced tea with a chicken cheese burger.", price: 259 },
        { name: "Lemon Iced Tea With Hara Bhara Kebab Wrap", desc: "Lemon iced tea with a crunchy hara bhara kebab wrap.", price: 239 },
        { name: "Lemon Iced Tea With Peri Peri Chicken Wrap", desc: "Lemon iced tea with a spicy peri peri chicken wrap.", price: 259 },
        { name: "Lemon Iced Tea With Vada Pav", desc: "Lemon iced tea with a classic vada pav.", price: 179 },
        { name: "Milk Hot Chocolate With Butter Croissant", desc: "Creamy hot chocolate with a flaky butter croissant.", price: 219 },
        { name: "Peach Coconut Matcha With Peri Peri Fries", desc: "Tropical peach coconut matcha with peri peri fries.", price: 259 },
      ]},
    ],
  },
  {
    key: "breakfast-snacks", label: "Breakfast & Snacks", image: u("1533089860892-a7c6f0a88666"),
    subcategories: [
      { label: "Breakfast", items: [
        { name: "Indori Poha", desc: "Classic Indori-style poha served with sev, peanuts and a hint of sweetness.", price: 99 },
        { name: "Khala Chaana Chaat", desc: "Protein-rich kala channa chaat with Indian spices and lemon.", price: 119 },
        { name: "Mini Idli [10 Pcs]", desc: "Soft, bite-sized idlis served with hari chutney and coconut chutney.", price: 129 },
        { name: "Poha", desc: "Light flattened rice cooked with onions, peanuts and mild spices.", price: 89 },
        { name: "Upma", desc: "Soft, savory semolina cooked with mustard seeds, curry leaves and mild spices.", price: 99 },
      ]},
      { label: "Snacks", items: [
        { name: "Bun Samosa", desc: "Oven-toasted bun with a deep-fried samosa and chutneys.", price: 99 },
        { name: "Bun Maska", desc: "Bun toasted with a generous dollop of butter.", price: 79 },
        { name: "Vada Pav", desc: "Toasted pav served with a spicy potato vada.", price: 79 },
        { name: "Samosa Chaat", desc: "Crispy puffed rice and samosa tossed in spicy chaat masala.", price: 129 },
        { name: "Pav Bhaji", desc: "Buttery pav bhaji served with lemon wedges and chopped onions.", price: 149 },
        { name: "Veg Maggi", desc: "Veg Maggi tossed with an assortment of veggies.", price: 99 },
        { name: "Chicken Keema Pav", desc: "Spicy minced chicken cooked with aromatic spices, served with butter-toasted pav.", price: 179 },
        { name: "Peri Peri French Fries", desc: "Crispy golden fries tossed in bold, zesty peri peri seasoning.", price: 129 },
        { name: "Paneer Puff", desc: "Flaky golden pastry filled with spiced paneer and veggies.", price: 89 },
      ]},
    ],
  },
  {
    key: "tea", label: "Signature Tea", image: u("1544787219-7f47ccb76574"),
    subcategories: [
      { label: "Hot Tea", items: [
        { name: "Kulhad Chai", desc: "Authentic spiced milk tea served in a traditional earthen kulhad.", price: 59 },
        { name: "Gur Wali Chai", desc: "Flavourful jaggery chai made with saunf.", price: 69 },
        { name: "Honey Ginger Lemon Tea", desc: "Honey ginger lemon tea — the perfect tonic to beat your cold.", price: 79 },
        { name: "Sulaimani Black Tea", desc: "Smooth Sulaimani chai with clove, cardamom, cinnamon, lemon and ginger.", price: 69 },
        { name: "Green Tea", desc: "Antiviral green tea made without sugar to boost immunity.", price: 69 },
        { name: "Kadak Chai", desc: "Homestyle masala tea.", price: 49 },
      ]},
      { label: "Iced Tea", items: [
        { name: "Lemon Iced Tea", desc: "Refreshing lemon-flavoured iced drink to revitalise your senses.", price: 129 },
        { name: "Peach Iced Tea", desc: "Refreshing peach-flavoured iced drink to revitalise your senses.", price: 129 },
      ]},
      { label: "Bubble Tea", items: [
        { name: "Classic Coffee Bubble Tea", desc: "Cold coffee blended with popping coffee-flavoured boba.", price: 179 },
        { name: "Strawberry Bubble Tea", desc: "Fruity strawberry popping boba with iced strawberry creamy milk.", price: 179 },
      ]},
      { label: "Matcha", items: [
        { name: "Strawberry Matcha", desc: "A refreshing blend of creamy matcha and sweet strawberry.", price: 199 },
        { name: "Peach Coconut Matcha", desc: "A tropical twist blending juicy peach and smooth coconut with matcha.", price: 209 },
        { name: "Honey Caramel Matcha", desc: "A smooth fusion of earthy matcha, rich caramel and natural honey.", price: 209 },
        { name: "Mango Matcha", desc: "A vibrant blend of tropical mango and earthy matcha.", price: 209 },
        { name: "Blueberry Creamy Fluffy Matcha", desc: "Earthy matcha, sweet blueberries and a light creamy texture.", price: 219 },
      ]},
    ],
  },
  {
    key: "sandwiches-burgers", label: "Sandwiches & Burgers", image: u("1513104890138-7c749659a591"),
    subcategories: [
      { label: "Veg Sandwiches", items: [
        { name: "Bombay Grill Sandwich", desc: "Mixed veggies and boiled potato grilled and served with brown bread.", price: 149 },
        { name: "Kadhai Paneer Sandwich", desc: "Cottage cheese tossed in kadhai sauce with mixed vegetables.", price: 179 },
        { name: "Creamy Mushroom Sandwich", desc: "Creamy mushroom, buttery croissant and a touch of garlic herb sauce.", price: 179 },
        { name: "Junglee Paneer Sandwich", desc: "Grilled sandwich loaded with spiced paneer, veggies and tangy sauces.", price: 179 },
      ]},
      { label: "Non-veg Sandwiches", items: [
        { name: "Chicken And Cheese Sandwich", desc: "Chicken, matured cheddar, tangy mayo on toasted sourdough.", price: 199 },
        { name: "Chicken Tikka Sandwich", desc: "Tikka-marinated chicken, pickled onions, lettuce and cilantro mayo.", price: 209 },
      ]},
      { label: "Veg Burgers", items: [
        { name: "Veg Cheese Burger", desc: "Veggie patty layered with melted cheese, lettuce and tangy sauce.", price: 149 },
        { name: "Spicy Paneer Burger", desc: "Grilled paneer patty in bold spices with cheese and crisp lettuce.", price: 169 },
        { name: "Aloo Tikki Burger", desc: "Crispy potato patty with cheese, veggies and tangy sauce.", price: 139 },
      ]},
      { label: "Non Veg Burgers", items: [
        { name: "Chicken Cheese Burger", desc: "Juicy chicken patty with melted cheese, lettuce and creamy sauce.", price: 189 },
        { name: "Egg & Cheese Burger", desc: "Fluffy egg with melted cheese and zesty sauce in a soft bun.", price: 169 },
        { name: "Spicy Chicken Burger", desc: "Crispy spicy chicken patty with cheese, lettuce and creamy sauce.", price: 199 },
      ]},
    ],
  },
  {
    key: "shakes-lemonades", label: "Shakes & Lemonades", image: u("1572490122747-3968b75cc699"),
    subcategories: [
      { label: "Milk Shakes", items: [
        { name: "Caramel Kit Kat Milk Shake", desc: "Caramelised milk chocolate blended with vanilla ice cream and whipped cream.", price: 199 },
        { name: "Oreo Milk Shake", desc: "Delicious Oreo cookies blended with vanilla ice cream.", price: 189 },
        { name: "Blue Berry Milk Shake", desc: "Blueberry shake topped with cream.", price: 189 },
        { name: "Blue Berry Blast Smoothie", desc: "Plump, juicy blueberries with creamy yogurt.", price: 199 },
        { name: "Mix Berry Smoothie", desc: "Strawberry, raspberry and blackberry blended with oats and honey.", price: 199 },
        { name: "Sweet Lassi", desc: "Sweet and thick yogurt drink flavoured with goodness.", price: 99 },
      ]},
      { label: "Lemonades", items: [
        { name: "Mint Mojito", desc: "A refreshing blend of fresh mint leaves, lime and soda, served chilled.", price: 119 },
        { name: "Fresh Lime Soda", desc: "Sparkling blend of tangy lime juice, fizzy soda and a hint of salt.", price: 99 },
      ]},
    ],
  },
  {
    key: "coffee", label: "Coffee", image: VERIFIED.latteTop,
    subcategories: [
      { label: "Hot Coffee", items: [
        { name: "Cappuccino", desc: "Espresso with equal parts hot milk and steamed microfoam.", price: 129 },
        { name: "Cafe Latte", desc: "Espresso with extra milk and steamed microfoam.", price: 139 },
        { name: "Cafe Mocha", desc: "Espresso with steamed milk and chocolate.", price: 159 },
        { name: "Americano", desc: "Espresso with hot water.", price: 119 },
        { name: "Espresso", desc: "Concentrated dose of coffee brewed under intense pressure.", price: 99 },
        { name: "Flat White", desc: "Double espresso with steamed milk microfoam, served warm.", price: 149 },
        { name: "Cortado", desc: "Double espresso with equal steamed milk microfoam, served warm.", price: 149 },
        { name: "Affogato", desc: "Espresso poured over ice cream.", price: 169 },
        { name: "Macchiato", desc: "Double espresso with a dash of textured milk.", price: 139 },
        { name: "French Press", desc: "A rich, full-bodied brew all about robust flavour and strength.", price: 159 },
      ]},
      { label: "Cold Coffee", items: [
        { name: "Classic Cold Coffee (No Added Sugar)", desc: "Double espresso with milk and ice cubes.", price: 179 },
        { name: "Cafe Frappe", desc: "Double espresso with milk, blended with ice cream.", price: 199 },
        { name: "Lotus Biscoff Frappe", desc: "Double espresso with milk and Biscoff spread, blended with ice cream.", price: 219 },
      ]},
      { label: "Iced Coffee", items: [
        { name: "Iced Cafe Mocha", desc: "Espresso, cocoa powder, milk and topped with ice.", price: 179 },
        { name: "Iced Americano", desc: "Double espresso extracted over ice and water.", price: 149 },
        { name: "Iced Cappuccino", desc: "Double espresso over ice and milk, topped with foam.", price: 169 },
        { name: "Iced Latte", desc: "Double espresso extracted over ice and milk.", price: 169 },
        { name: "Cold Brew", desc: "Coffee steeped overnight, triple-filtered for smoothness and low acidity.", price: 199 },
      ]},
    ],
  },
  {
    key: "wraps-rolls", label: "Wraps & Rolls", image: u("1533089860892-a7c6f0a88666"),
    subcategories: [
      { label: "Veg Wraps", items: [
        { name: "Spicy Paneer Wrap", desc: "Succulent paneer patty with tangy mayo, crunchy peppers and homemade sauce.", price: 159 },
        { name: "Hara Bhara Kebab Wrap", desc: "Spinach, peas and potato patties deep-fried to crunchy perfection.", price: 149 },
      ]},
      { label: "Non Veg Wraps", items: [
        { name: "Peri Peri Chicken Wrap", desc: "Succulent chicken patty, tangy mayo, peppers and homemade peri peri sauce.", price: 199 },
        { name: "Spicy Chicken Wrap", desc: "Tender chicken in a spicy sauce, wrapped with fresh veggies.", price: 199 },
      ]},
      { label: "Veg Rolls", items: [
        { name: "Aloo Roll", desc: "Spiced potato filling wrapped in a soft roti with onions and sauces.", price: 129 },
        { name: "Classic Paneer Roll", desc: "Soft roti filled with spiced paneer, onions and sauces.", price: 149 },
      ]},
      { label: "Non-veg Rolls", items: [
        { name: "Classic Chicken Keema Roll", desc: "Spiced chicken mince wrapped in a soft roti with onions and sauces.", price: 179 },
        { name: "Classic Egg Roll", desc: "Soft flatbread rolled with fluffy egg omelette, spices, onions and sauces.", price: 149 },
      ]},
    ],
  },
  {
    key: "teaavi-special", label: "Teaavi Special", image: VERIFIED.cappuccino,
    subcategories: [
      { label: "Thick Hot Chocolate", items: [
        { name: "Milk Hot Chocolate", desc: "Luxurious hot chocolate made with creamy milk chocolate.", price: 159 },
        { name: "Dark Hot Chocolate", desc: "Luxurious hot chocolate made with 70% dark chocolate.", price: 169 },
      ]},
      { label: "Desserts", items: [
        { name: "Brownie", desc: "Decadent chocolate brownie with a melt-in-the-mouth texture.", price: 129 },
        { name: "Muffins", desc: "Soft, freshly baked muffins — Almond, Choco Chip or more.", price: 99 },
        { name: "Cheese Cake", desc: "Delicious cheesecake — KitKat, Biscoff or Very Berry.", price: 199 },
        { name: "Cake", desc: "Delicious cake — Marble, Lemon or Carrot.", price: 149 },
        { name: "Plain Butter Croissant", desc: "Flaky, buttery croissant baked to perfection.", price: 119 },
      ]},
    ],
  },
  {
    key: "healthy-combo", label: "Healthy Combo", image: u("1546173159-315724a31696"),
    subcategories: [
      { label: "Balanced Boxes", items: [
        { name: "Refresh & Grill Combo", desc: "Fresh Lime Soda + Bombay Grill Sandwich — a revitalising, balanced pick.", price: 229 },
        { name: "Ginger Vitality Combo", desc: "Kulhad Adrak Chai + Bun Maska (Light) — soothing, immunity-supporting.", price: 179 },
        { name: "Lean Energy Fuel Box", desc: "Cold Coffee (No Sugar) + Chicken Cheese Burger (No Mayo) — clean and lean.", price: 269 },
        { name: "Mindful Protein Power Meal", desc: "Cappuccino + Chicken & Cheese Sandwich (Lite) — lean, protein-rich.", price: 259 },
        { name: "Jaggery Wellness Pair", desc: "Gur Wali Chai + Hara Bhara Kebab Wrap — naturally sweet and mineral-rich.", price: 229 },
      ]},
    ],
  },
];

export const SIGNATURE = [
  { name: "Cafe Frappe", desc: "Double espresso with milk, blended with ice cream.", price: 199, image: VERIFIED.latteTop },
  { name: "Lotus Biscoff Frappe", desc: "Espresso, milk & Biscoff spread blended with ice cream.", price: 219, image: u("1461023058943-07fcbe16d735") },
  { name: "Honey Caramel Matcha", desc: "Earthy matcha, rich caramel and natural honey.", price: 209, image: u("1536256263959-770b48d82b0a") },
  { name: "Strawberry Matcha", desc: "Creamy matcha balanced with sweet strawberry.", price: 199, image: u("1546173159-315724a31696") },
  { name: "Kulhad Chai", desc: "Authentic spiced milk tea in a traditional earthen kulhad.", price: 59, image: u("1544787219-7f47ccb76574") },
  { name: "Caramel Kit Kat Milk Shake", desc: "Caramelised chocolate blended with vanilla ice cream.", price: 199, image: u("1572490122747-3968b75cc699") },
  { name: "Dark Hot Chocolate", desc: "Luxurious hot chocolate made with 70% dark chocolate.", price: 169, image: VERIFIED.cappuccino },
  { name: "Classic Cold Coffee", desc: "Double espresso with milk and ice — no added sugar.", price: 179, image: u("1517701550927-30cf4ba1dba5") },
];

export const GALLERY = [
  { label: "Café Interior", image: VERIFIED.interior1, span: "md:col-span-7" },
  { label: "Coffee Art", image: VERIFIED.latteTop, span: "md:col-span-5" },
  { label: "Food", image: VERIFIED.bakery, span: "md:col-span-5" },
  { label: "Outdoor Seating", image: u("1676188043163-9f16eac1f2ac"), span: "md:col-span-7" },
  { label: "Live Music", image: u("1693214893115-9ea8d05ccf1d"), span: "md:col-span-6" },
  { label: "Happy Customers", image: u("1668000305847-cf422c116bf8"), span: "md:col-span-6" },
];

export const FEATURES = [
  { title: "Freshly Brewed Coffee", icon: "Coffee" },
  { title: "Premium Ingredients", icon: "Leaf" },
  { title: "Cozy Ambience", icon: "Armchair" },
  { title: "Free Wi-Fi", icon: "Wifi" },
  { title: "Fast Service", icon: "Zap" },
  { title: "Friendly Staff", icon: "HeartHandshake" },
  { title: "Fresh Bakery", icon: "Croissant" },
  { title: "Family Friendly", icon: "Users" },
];

export const REVIEWS = [
  { name: "Aarav Mehta", role: "Regular", text: "Best coffee in town! The Lotus Biscoff Frappe is unreal and the space is pure calm." },
  { name: "Sofia Alvarez", role: "Foodie", text: "Amazing ambience and delicious food. Their croissants melt in your mouth." },
  { name: "Daniel Okonkwo", role: "Freelancer", text: "Perfect place for work and meetings. Fast Wi-Fi and bottomless cold brew." },
  { name: "Priya Nair", role: "Student", text: "Cozy corners, warm staff and the student discount keeps me coming back." },
];

export const OFFERS = [
  { title: "Happy Hours", desc: "20% off all beverages, 4–6 PM daily.", tag: "Daily" },
  { title: "Buy 1 Get 1 Coffee", desc: "Every Monday on all hot coffees.", tag: "Mondays" },
  { title: "Student Discount", desc: "Flat 15% off with a valid student ID.", tag: "Always" },
  { title: "Weekend Specials", desc: "Curated brunch sets every Sat & Sun.", tag: "Weekends" },
  { title: "Corporate Catering", desc: "Custom packages for teams & offices.", tag: "On request" },
];

export const EVENTS = [
  { title: "Open Mic", desc: "Share poetry, music & stories every Thursday night.", type: "Open Mic" },
  { title: "Live Music", desc: "Acoustic sets & local bands on weekends.", type: "Live Music" },
  { title: "Birthday Parties", desc: "Celebrate with custom cakes & décor.", type: "Birthday Party" },
  { title: "Corporate Meetups", desc: "Private space, Wi-Fi & catering for teams.", type: "Corporate Meetup" },
  { title: "Coffee Workshops", desc: "Learn latte art & brewing from our baristas.", type: "Coffee Workshop" },
  { title: "Video / Photo Shoots", desc: "Rent our space with a clean white backdrop for shoots.", type: "Video / Photo Shoot" },
];

export const LOCATIONS = [
  {
    name: "Teaavi Coffee — Sector 67", city: "Delhi NCR",
    address: "Lower Ground Floor, Badshahpur, Near Cyber Park, Sector 67, Gurugram, Delhi NCR",
    hours: "7:00 AM – 11:00 PM", image: VERIFIED.interior1,
    lat: 28.3928, lng: 77.0508,
    maps: "https://www.google.com/maps/search/?api=1&query=Cyber+Park+Sector+67+Gurgaon",
  },
  {
    name: "Teaavi Coffee — Mega Mall", city: "Delhi NCR",
    address: "Golf Course Rd, A Block, DLF Phase 1, Gurugram, Delhi NCR 122002", hours: "10:00 AM – 11:00 PM", image: VERIFIED.interior2,
    lat: 28.4770, lng: 77.0916,
    maps: "https://www.google.com/maps/search/?api=1&query=Mega+Mall+Golf+Course+Road+DLF+Phase+1+Gurugram",
  },
  {
    name: "Teaavi Coffee — Sector 29", city: "Delhi NCR",
    address: "389, Sector 29, Gurugram, Delhi NCR 122009", hours: "8:00 AM – 12:00 AM", image: VERIFIED.bakery,
    lat: 28.4682, lng: 77.0797,
    maps: "https://www.google.com/maps/search/?api=1&query=389+Sector+29+Gurugram+Haryana+122009",
  },
];

export const CONTACT = {
  phone: "+91 84483 98100",
  whatsapp: "918448398100",
  email: "hello@teaavicoffee.com",
  address: "Lower Ground Floor, Badshahpur, Near Cyber Park, Sector 67, Gurugram, Delhi NCR",
  hours: [
    { day: "Mon – Fri", time: "7:00 AM – 11:00 PM" },
    { day: "Sat – Sun", time: "8:00 AM – 12:00 AM" },
  ],
  socials: { instagram: "#", facebook: "#", whatsapp: "https://wa.me/918448398100" },
};
